import { StyleSheet, View } from 'react-native';

import { tokens } from '@fhs/ui';

import { BackgroundVideoPlayer } from './background-video-player';

type BackgroundVideoProps = {
  aspectRatio?: string | number;
  videoUrl?: string | null;
  posterUrl?: string | null;
  mediaAltText: string;
  loading?: 'eager' | 'lazy';
  width: number;
  height: number;
  hideFromAccessibility?: boolean;
};

export default function BackgroundVideo({
  aspectRatio = '16 / 9',
  videoUrl,
  posterUrl,
  mediaAltText,
  width,
  height,
  hideFromAccessibility = false,
}: BackgroundVideoProps) {
  const mediaStyle = {
    aspectRatio,
    minWidth: width,
    minHeight: height,
  } as const;

  return (
    <View style={styles.wrapper}>
      <BackgroundVideoPlayer
        videoUrl={videoUrl}
        posterUrl={posterUrl}
        mediaAltText={mediaAltText}
        style={mediaStyle}
        hideFromAccessibility={hideFromAccessibility}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    backgroundColor: tokens.colors.$houseDark,
    overflow: 'hidden',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
